<template>
  <div class="page_model">
    <iframe style="width: 99%;height: 100vh;" :src="url"></iframe>
  </div>
</template>

<script>
  import xz from "@/common";
  export default {
    data() {
      return {
        url:`https://view.officeapps.live.com/op/view.aspx?src=` + encodeURIComponent('https://emp.joball.net/cloudexcel/excel/E20231107151241922.xlsx')
      }
    },
    async created() {
      this.$store.commit('setHiddenLeft', true)
    },
    methods: {}
  }
</script>
<style scoped>
</style>